import element from './element-ui'
import UserAnswer from './UserAnswer'
import PublishProject from './PublishProject'
import SetUp from './SetUp'
import Appearance from './Appearance'
import DataRecycling from './DataRecycling'
import Preview from './Preview'
import QuesLibrary from './QuestionnaireLibrary'
import Personal from './Personal'
import Mywallet from './Mywallet'
import Quota from './Quota'

const lang = {
  main:{
    // 问卷列表以及公共部分
    message:"Mesej 1",
    display:"Paparkan 1",
    ok: 'OK',
    cancel: 'Batalkan',
    ok2: 'OK',
    cancel2: 'Batalkan',
    Restore: 'Pulih',
    delete: 'Padam',
    GoToMyDownload: 'Data sedang disediakan, dijangka siap dalam 5 minit. Beralih ke <a href="#/Projek Saya/">My Download</a> untuk semak status muat turun',
    save: 'Simpan',
    save1: 'Simpan',
    pleaseEnterYourPhoneNumber: 'Sila masukkan nombor telefon bimbit',
    enterOneUserName: 'Sila masukkan nama pengguna',
    pleaseInputPassword: 'Sila masukkan kata laluan',
    PleaseEnterValidPhoneNumber: 'Sila masukkan nombor telefon bimbit yang berkesan',
    SMSSentSuccessfully: 'Hantaran SMS berjaya!',
    MyQuestionnaire: 'Soal selidik saya',
    MyExam: 'Ujian saya',
    QuesLibrary: 'Bank Soal Silidik',
    ExamQuestionBank: 'Bank Soalan',
    UserManagement: 'Pengurusan pengguna',
    userInformation: 'Butiran pengguna',
    myDownloads: 'Muat turun saya',
    myWallet: 'e-dompet saya',
    CustomerServiceCenter: 'Pusat khidmat pelanggan',
    liaison: 'Penghubung',
    advancedSetting: 'Tetapan lanjutan',
    QuestionnaireStatus: 'Status soal selidik',
    CreationTime: 'Masa pembinaan',
    DeleteTime: 'Padamkan masa',
    PleaseEnterContent: 'Sila masukkan kandungan',
    recycleBin: 'Peti kitar semula',
    title: 'Tajuk',
    type: 'Jenis',
    state: 'Status',
    Editing: 'Menyunting',
    ConscriptionConcentration: 'Mengumpul',
    Ended: 'Telah tamat',
    inReview: 'Sedang ditinjaui',
    collectData: 'Kumpul data',
    time: 'Masa',
    operate: 'Operasi',
    edit: 'Edit',
    Preview: 'Pratonton',
    Release: 'Lepaskan',
    data: 'Data',
    PublishProject: 'Terbitkan Projek',
    PreviewProject: 'Pratonton Projek',
    CopyProject: 'Salin Projek',
    wipeData: 'Padamkan data',
    deleteItem: 'Padamkan Item',
    questionnaire: 'Soal Selidik',
    ThereIsCurrentlyNoDataAvailable: 'Tiada data buat masa ini',
    PleaseEnterYourLoginPassword: 'Sila mauskkan kata laluan untuk log masuk',
    whole: 'Semua',
    Completed: 'Siap',
    PleaseSelectAPieceOfData: 'Sila pilih sebuah data',
    DataPreparationIsUnderway: 'Data sedang disediakan, dijangka siap dalam 5 minit. Beralih ke',
    CanViewProgress: 'untuk semak status muat turun',
    PleaseEnterTheAccountPassword: 'Sila masukkan kata laluan untuk akaun。',
    DoYouWantToClearTheCurrentData: 'Pastikan anda hendak memadamkan data semasa?',
    tip: 'Tip',
    EmptyCanceled: 'Mengosongkan telah dibatalkan',
    CanBeRestored: 'Projek dipadamkan akan dipindah ke peti kitar semula, boleh dipulihkan.',
    ImportWasSuccessful: 'Import Berjaya',
    ImportFailed: 'Import gagal, sila import lagi',
    SuccessfullyCopiedProject: 'Penyalinan projek berjaya!',
    ImportQuestionnaire: 'Import soal selidik',
    DownloadTemplate: 'Muat turun templat',
    DownloadToLocal: 'Klik untuk  muat turn templat soal selidik setempat',
    AutomaticallyGenerateQuestionnaires: 'Klik import soal selidik untuk memperolehi soal selidik secara automatik',
    ModificationPrompt: 'Gesaan pengubahsuaian',
    QuestionnaireCollected: 'Soal selidik telah dikumpul',
    PausePublishing: 'Mengubahsuai soal selidik boleh menjejaskan data yang dikumpul. Apabila soal selidik diubah suai, penerbitan akan digantung. Anda perlu menerbitkan semula selepas pengubahsuaian untuk meneruskan pengumpulan data.',
    PausePublishingPrompt: 'Gesaan jeda penerbitan',
    PausePublishingPromptText: 'Pelepasan soal selidik akan digantung apabila anda mengubahsuai soal selidik. Anda perlu menerbitkan semula soal selidik selepas pengubahsuaian selesai untuk meneruskan pengumpulan data. Pautan soal selidik asal tidak akan berubah.',
    CreateABlankQuestionnaire: 'Bina soal selidik kosong',
    ReferenceTemplate: 'Templat rujukan',
    EditItem: 'Edit Item',
    Dataecycling: 'Kitar semula data',
    ExitListPage: 'Nombor soal selidik semasa telah hilang, ini mungkin disebabkan oleh penggosongan cache pelayar. Sistem akan keluar ke laman senarai.',
    PleaseEnterKeywordSearch: 'Sila masukkan kata kunci carian',
    SearchFor: 'Carian',
    // 问卷设计
    export: 'Eksport',
    import: 'Import',
    useTest: 'Pengunaan ujian',
    OptionGrouping: 'Kumpulan opsyen',
    OptionsToBeGrouped: 'Opsyen untuk dikumpulankan',
    GroupedlTips: 'Tip：Sila pilih opsyen di sebelah kiri dan sertai kumpulan di sebelah kanan',
    GroupManagement: 'Pengurusan kumpulan',
    AddGroup: 'Tambah kumpulan',
    join: 'Sertai',
    GroupName: 'Nama Kumpulan',
    moveUp: 'Gerak ke atas',
    MoveDown: 'Gerak ke bawah',
    QuestionType: 'Jenis soalan',
    Appearance: 'Penampilan',
    questionBank: 'Bank soalan',
    outline: 'Rumusan',
    copy: 'Salin',
    paste: 'Tampal',
    clickQuestionTypeAddQuestion: 'Klik Jenis Soalan untuk tambah soalan',
    CompleteEditing: 'Siap edit',
    QuestionSetting: 'Tetapan soalan',
    pageNumber: 'Nombor muka surat',
    WholeQuestionSetting: 'Tetapan soalan keseluruhan',
    QuestionMustAnswered: 'Soalan ini wajib dijawab',
    ProblemCode: 'Kod soalan',
    ProblemCodeHasBeenUsedAndCannotBeReused: 'Kod soalan telah dipakai, tidak boleh digunakan semula',
    uniqueIdentification: 'Pengecam unik',
    MaximumNumberOfUploadedFiles: 'Bilangan maksima fail yang boleh dimuat naik',
    PleaseSelect: 'Sila pilih',
    DisplayStyle: 'Gaya paparan',
    lowestScore: 'Markah terendah',
    MinimumScoreMustNotBeGreaterThanOrEqualToTheMaximumScore: 'Markah terendah tidak boleh melebihi atau sama dengan markah tertinggi',
    highestScore: 'Markah tertinggi',
    highestScoreMustNotBeLessThanOrEqualToTheLowestScore: 'Markah tertinggi tidak boleh kurang daraipada atau sama dengan markah terendah',
    LogicalSettings: 'Tetapan logik',
    AddLogicalPrompts: 'Selepas menambah tetapan logik, responden boleh beralih ke soalan yang berbeza mengikut jawapan yang dipilih',
    setUp: 'Tetapan',
    MutualExclusionInfluence: 'Pengecualian dan pengaruhan',
    MutualExclusion: 'Pengecualian',
    Effect: 'Kesan',
    AdvancedScripting: 'Skrip lanjutan',
    DisplayLineOfIncidenceMatrixQuestion: 'Paparkan baris soalan matriks korelasi baris',
    SumOfRestrictedSpecificGravity: 'Hadkan jumlah perkadaran',
    TotalSpecificGravity: 'Jumlah perkadaran',
    PromptText: 'Teks gesaan',
    LeftPromptText: 'Sebelah kiri',
    IntermediatePromptText: 'Tengah',
    PromptTextOnTheRight: 'Sebelah kanan',
    ManualPositionCorrectionNotAllowed: 'Pembetulan posisi secara manual tidak dibenarkan',
    InputBoxSize: 'Saiz kotak input',
    small: 'Kecil',
    middle: 'Medium',
    big: 'Besar',
    QuestionTypeSwitching: 'Tukar jenis soalan',
    SingleRow: 'Satu baris',
    multipleRows: 'Pelbagai baris',
    Radio: 'Pilih satu',
    MultipleChoice: 'Pilihan pelbagai',
    RandomArrangementOfRows: 'Susun baris secara rawak',
    RandomArrangementOfColumns: 'Susun lajur secara rawak',
    MatrixRowColumnExchange: 'Tukar baris/lajur matriks',
    FillingBoxOnTheMobilePhoneCanSlideToAppear: 'Kotak isian pada telefon bimbit akan muncul apabila dianjak',
    PagingSettings: 'Tetapan laman',
    applyToAll: 'Gunakan untuk semua',
    MinimumTime: 'Masa minima',
    MinimumTimeToStayOnThisPage: 'Masa minima untuk kekal di laman ini',
    EnterSeconds: 'Masukkan saat',
    second: 'Saat',
    MaximumTime: 'Masa maksima',
    PageNeedsToStayForTheLongestTime: 'Masa maksima untuk kekal di laman ini',
    MoreSettings: 'Lebih banyak tetapan',
    PreviousButtonText: 'Teks untuk butang laman sebelumnya',
    NextPageButtonText: 'Teks untuk butang laman seterusnya',
    ShowPreviousPagButton: 'Paparkan butang laman sebelumnya',
    OptionalRange: 'Julat pilihan',
    theLeast: 'Paling kurang',
    noLimit: 'Tiada had',
    term: 'Item',
    atMost: 'Paling banyak',
    OptionSettings: 'Tetapan opsyen',
    subset:'Subset',
    OptionGroupingPrompt: 'Tetapan kumpulan opsyen boleh membantu responden menjawab soalab dengan lebih cekap apabila terdapat banyak opsyen.',
    DetailLevel: 'Tahap perincian',
    RandomlyArrangeOptions: 'Susun opsyen secara rawak',
    FixTheLastOption: 'Tetapkan opsyen terakhir',
    LimitSpecificGravityMinimumMaximumValue: 'Hadkan perkadaran nilai minima/maksima',
    minimumValue: 'Minima',
    minimumMustNotBeGreaterThanOrQqualToTheMaximumValue: 'Nilai minima tidak boleh melebihi atau sama dengan nilai maksima',
    MaximumValue: 'Maksima',
    OnlySelect: 'Pilih sahaja',
    place: 'Tempat',
    OptionLayout: 'Opsyen tataletak',
    arrange: 'Susun',
    OptionAssociation: 'Kaitan opsyen',
    LabelSettings: 'Tetapan label',
    tagName: 'Nama label',
    PleaseEnterALabelName: 'Sila masukkan nama label',
    SettingsFor: 'Tetapan untuk',
    AddAFillInBoxAfterTheOption: 'Tambah kotak untuk isi tempat kosong selepas opsyen',
    ContentRestrictions: 'Batasan  untuk kandungan',
    WordLimit: 'Had kiraan kata',
    WithinWords: 'Dalam perkataan',
    formatLimits: 'Had format',
    FillInAtLeast: 'Isi sekurang-kurangnya',
    FillInAtMost: 'Isi sebanyak-banyaknya',
    DefaultText: 'Teks lalai',
    ThisBlankCanBeLeftBlank: 'Boleh dikosongkan',
    questionBank: 'Bank soalan',
    problem: 'Masalah',
    increase: 'Tambah',
    FillInTheBlankAttribute: 'Isi atribut kosong',
    FillInTheBlankNumber: 'Isi nombor kosong',
    WordRange: 'Julat kiraan kata',
    ThisBlankIsMandatory: 'Mesti diisi',
    HowManyWordsCanIFillInAatMost: 'Nombor maksima untuk diisi',
    word: 'Kata',
    BatchAddOptions: 'Tambah opsyen secara kumpulan',
    EditTitle: 'Edit tajuk',
    SetTheQuestion: 'Tetapkan soalan',
    PleaseSelectAnOption: 'Sila pilih opsyen',
    SelectedItemsAsOptionsForThisQuestion: 'Tetapkan item ini sebagai opsyen untuk soalan ini',
    FinishedEditing: 'Siap edit, menerbitkan segera?',
    continueEditing: 'Teruskan edit',
    PublishNow: 'Menerbitkan segera',
    percentage:'Peratus',
    Selected: 'Terpilih',
    notSelected: 'Tidak dipilih',
    show: 'Tunjukkan',
    NoShow: 'Jangan tunjukkan',
    numeral: 'Nombor',
    letter: 'Abjad',
    Chinese: 'Bahasa Cina',
    Email: 'Emel',
    cellPhoneNumber: 'Nombor tekefon bimbit',
    Url: 'Url',
    ID: 'ID',
    Item1: 'Perkara 1',
    Item2: 'Perkara 2',
    DetailedToDetailedAddress: 'Terperinci sehinggag "Alamat terperinci"',
    DetailedToCity: 'Terperinci sehinggag "Bandar"',
    DetailedTopProvince: 'Terperinci sehinggag "Wilayah"',
    maximumValueMustNotBeLessThanOrEqualToTheMinimumValue: 'Nilai maksima tidak boleh kurang daripada nilai minima',
    ReplicatingSuccess: 'Salinan berjaya',
    PleaseSelectTheTestQuestionFirst: 'Sila pilih soalan',
    ThereAreCurrentlyNoTestQuestionsToPaste: 'Tiada soalan boleh ditampal buat masa ini',
    CannotBeEmpty: 'Tidak boleh dikosongkan',
    PleaseSelectAFile: 'Sila pilih fail',
    fileReadFailure: 'Fail tidak dapat dibaca, sila semak',
    maximumValueMustNotExceedTheTotalSpecificGravity: 'Nilai maksima tidak boleh lebih besar daripada jumlah perkadaran',
    ImageUploadQuestionDidNotUploadImages: 'Gambar masih belum dimuat naik di soalan muat naik gambar',
    EnterAtLeastOneOption: 'Masukkan sekurang-kurangnya 1 opsyen!',
    option: 'Opsyen',
    matrix: 'Matriks',
    SuccessfullyAppliedToAll: 'Gunaan untuk semua berjaya！',
    NoOptionsAvailable: 'Tiada opsyen yang sedia ada, sila tetapkan!',
    AddedSuccessfully: 'Tambahan bejaya!',
    questionHasAlreadyParticipatedInLogicalSetting: 'Soalan ini telah terlibat dalam tetapan logik di soalan lain, tidak boleh dipadamkan!',
    questionOptionIsAlreadyAssociatedWithAnotherQuestion: 'Opsyen soalan telah dikaitkan dengan saolan lain, tidak boleh dipadamkan!',
    firstPageIsTheDefaultPage: 'Halaman pertama adalah halaman lalai, tidakboleh dipadamkan!',
    operationWillPermanentlyDeleteTheData: 'Operasi ini kan memadamkan semua data, diteruskan?',
    CancelledDeletion: 'Pemadaman telah dibatalkan',
    other: 'Lain-lain',
    PleaseRemoveTheOptionFromTheGroup: 'Sila batalkan opsyen daripada kumpulan',
    SuccessfullyDeletedTheOption: 'Pemadaman opsyen berjaya',
    member: 'Ahli',
    MatrixRow: 'Matriks baris',
    MatrixColumn: 'Maktriks Lajur',
    minimumOptionsCannotExceedTheMaximumOptions: 'Opsyen minima tidak boleh melebihi opsyen masima',
    QuestionnaireType: 'Jenis soal selidik',
    AssociatedFrom: 'Dikaitkann daripada',
    de: 'Daripada',
    Options: 'Opsyen',
    text: 'Teks',
    CancelFavorite: 'Batalkan simpanan',
    CancelFailed: 'Pembatalan gagal',
    CollectionSuccessful: 'Simpanan berjaya',
    SingleLineInputBox: 'Kotak satu baris',
    MultilineInputBox: 'Kotak perenggan',
    fillInTheBlanks: 'isi tempat kosong',
    CollectToQuestionBank: 'Simpan di bank soalan',
    ThereIsCurrentlyNoQuestionBankAvailable: 'Tiada bank soalan buat masa ini',
    CannotBeEmpty: 'Tidak boleh dikosongkan',
    create: 'Bina',
    CreateANewQuestionBank: 'BaruNew',
    Unclassified: 'Tidak diklasifikasi',
    AddOptions: 'Tambah opsyen',
    BatchAdd: 'Tambahan secara kumpulan',
    AddOther: 'Tambah lain-lain',
    NewOptions: 'Opsyen baru',
    multipleChoice: 'Pilihan pelbagai',
    UploadFailed: 'Muat naik gagal！',
    EachRowRepresentsOne: 'Setiap baris mewakili 1 pilihan',
    MultipleCanBeAdded: 'Boleh tambah pelbagai',
    MultipleOptionsCanAdded: 'Setiap baris mewakili 1 pilihan dan pelbagai pilihan boleh ditambah',
    determine: 'Menentukan',
    MultipleBlankFilling: 'Isi pelbagai tempat kosong',
    fillInTheBlanks: 'Isi tempat kosong',
    AddAndFillInTheBlank: 'Tambah dan isi tempat kosong',
    dropDown: 'Turunan',
    PictureSelection: 'Pilih gambar',
    Upload1SheetAtATime: 'Muat naik 1 helai pada satu masa sahaja',
    UpTo10CopiesCanBeUploaded: 'Muat naik sebanyak-banyaknay 10 helai sahaja',
    modify: 'Meminda',
    ValidationFailed: 'Pengesahan gagal',
    CurrentLimitSelection: 'Hanya boleh pilih sebanyak-banyaknya 3 gambar sahaja, sila padamkan satu dan pilih lagi jikalau hendak tukar gambar!',
    StarRating: 'Penarafan',
    score: 'Markah',
    ScaleQuestions: 'Soalan skala',
    DateSelection: 'Pilihan tarikh',
    year: 'Tahun',
    month: 'Bulan',
    day: 'Hari',
    SelectDate: 'Pilih tarikh',
    SortQuestion: 'Mengisih soalan',
    addressLocation: 'Lokasi',
    ClickToObtainGeographicalLocation: 'Klik untuk dapatkan lokasi',
    CitySelection: 'Pilihan bandar',
    PleaseSelectAProvince: 'Sila pilih wilayah/negeri',
    PleaseSelectACity: 'Sila pilih bandar',
    PleaseSelectADistrictOrCounty: 'Sila pilih daerah',
    PleaseFillInTheDetailedAddress: 'Sila isi alamat terperinci',
    MatrixRadioSelection: 'Matriks Pilih Satu',
    addRows: 'Tambah baris',
    AddColumn: 'Tambah lajur',
    BatchAddRows: 'Tambah baris secara kumpulan',
    BatchAddColumns: 'Tambah lajur secara kumpulan',
    InsertSpaceFiller: 'Masukkan Pengisi Kosong',
    KeepAtLeastOneOption: 'Tinggalkan sekurang-kurangnya satu opsyen',
    KeepAtLeastOneSubTopic: 'Tinggalkan sekurang-kurangnya satu sub topik！',
    MatrixMultipleSelection: 'Matriks Pilih Pelbagai',
    MatrixStarRating: 'Matriks penarafan ',
    Scoring: 'Pemarkahan',
    MatrixFillingInTheBlank: 'Matriks isi tempat kosong',
    PageNumber: 'Nombor muka surat',
    UploadFiles: 'Muat naik fail',
    ChooseToUploadFilesWithin10M: 'Pilih untuk muat nail fail(di bawah 10M)',
    Timing: 'Waktu',
    SelectTime: 'Masa',
    FillInTheBlankHorizontally: 'Isi Tempat Kosong Secare Menegak',
    TheLengthDeterminesTheWidthOfFillingInTheBlanks: 'Panjangnya menentukan lebar jawapan isi kosong',
    Range: 'Julat',
    CascadeQuestions: 'Soalan Bercabang',
    EditingOptions: 'Opsyen edit',
    Query: 'Pertanyaan',
    SpecificGravityQuestion: 'Soalan perkadaran',
    Proportion: 'Perkadaran',
    SetColumnProperties: 'Tetapkan format lajur',
    SetRowProperties: 'Tetapkan Ciri Baris',
    CurrentTopic: 'Topik semasa',
    ColumnHeader: 'Pengepala',
    RowHeader: 'Kepala baris',
    ValidateProperties: 'Pengesahan ciri',
    MinimumWordCount: 'Nilai kiraan kata minima',
    MaximumWordCount: 'Nilai kiraan kata maksima',
    MultilineText: 'Perenggan',
    SingleLineText: 'Teks sebaris',
    Integer: 'Integer',
    FixedLine: 'Talian tetap',
    DropdownOptions: 'Pilihan Drop Down',
    FileUpload: 'Muat Naik Fail',
    English: 'Bahasa Inggeris',
    TraditionalChinese: 'Bahasa Cina Traditional',
    FirstLevelOptions: 'Pilihan Perinkkat 1',
    SecondaryOptions: 'Pilihan Perinkkat 2',
    ThirdLevelOptions: 'Pilihan Perinkkat 3',
    FourthLevelOption: 'Pilihan Perinkkat 4',
    ThisOptionCannotBeDeleted: 'Pilihan opsyen tidak boleh dipadamkan',
    ImportOptions: 'Import Opsyen',
    ClickToUpload: 'Klik untuk muat naik',
    Download: 'Muat Turun',
    BatchAddQuestionTypes: 'Tambah jenis soalan secara kumpulan',
    ImportQuestion: 'Import soalan',
    PleaseSearchForTagsOrNamesOrQuestioBanks: 'Sila cari label/nama/bank soalan',
    SelfBuiltQuestionBank: 'Saya',
    Refresh: 'Segar Semula',
    Quote: 'Petikan',
    ThereIsCurrentlyNoContentAvailable: 'Tiada kandungan buat masa ini',
    SystemQuestionBank: 'Bank soalan sistem',
    QuestionBankName: 'Nama bank soalan',
    TheQuestionBankNameCannotBeEmpty: 'Nama bank soalan tidak boleh dikosongkan',
    Rename: 'Menamakan semula',
    DeleteAllQuestionsWithinTheGroup: 'Padamkan semua soalan di dalam kumpulan ini',
    DeleteConfirmation: 'Pasti memadamkan',
    ScaleSettings: 'Penetapan Skala',
    ExtremeValueLabel: 'Label nilai ekstrem',
    CustomContent: 'Penyesuaian kandungan',
    ScaleSetting: 'Penetapan Skala',
    Level: 'Peringkat',
    StartingValue: 'Nilai permulaan',
    PleaseEnterAValueWithinMax89: 'Sila masukkan nilai di antara -9 ke 89',
    PleaseEnterAValueWithinMax100: 'Sila masukkan nilai di antara -100 ke 100',
    PleaseEnterAValueWithinMax10: 'Sila masukkan nilai di antara 1 ke 10',
    Satisfaction: 'Kepuasan',
    Identity: 'Penerimaan',
    Willingness: 'Kesudian',
    Importance: 'Kepentingan',
    Conformance: 'Kesesuaian',
    Perception: 'Persepsi',
    Feasibility: 'Kebolehlaksanaan',
    Custom: 'Penyesuaian',
    VeryDissatisfied: 'Sangat tidak puas hati',
    VerySatisfied: 'Sangat puas hati',
    StronglyDisagree: 'Sangat tidak setuju',
    StronglyAgree: 'Sangat setuju',
    VeryReluctant: 'Sangat enggan',
    VeryWilling: 'Sangat rela',
    VeryUnimportant: 'Sangat tidak penting',
    VeryImportant: 'Sangat penting',
    VeryInconsistent: 'Sangat tidak konsisten',
    VeryConsistent: 'Sangat konsisten',
    Senseless: 'Tiada perasaan',
    VeryStrong: 'Sangat kuat',
    Impossible: 'Tidak mungkin',
    InAllLikelihood: 'Kemungkinan besar',
    ScoreSetting: 'Tetapan markah',
    ScoreConversionRatioOfThisQuestion: 'Nisbah pertukaran markah untuk soalan ini',
    ClosedLoopOrNot: 'Putaran tertutup atau tidak',
    FillingRestrictions: 'Had pengisian',
    MinimumMustNotBeGreaterThanOrEqualToMaximum: 'Nilai minima tidah boleh lebih besar atau sama dengan nilai maksima',
    MaximumMustNotBLessThanOrEqualToMinimum: 'Nilai maksima tidak boleh kurang atau sama dengan nilai minima',
    JumpLogic: 'Logik peralihan',
    JumpLogics: 'Logik peralihan',
    UnconditionalSkipQuestions: 'Melewatkan soalan tanpa sebarang syarat',
    SkipQuestionsAccordingToConditions: 'Melewatkan soalan berdasarkan syarat',
    AddLogic: 'Tambah logik',
    AfterAnsweringThisQuestionJumpTo: 'Selepas menjawab soalan ini, beralih ke',
    PleaseSelectAQuestion: 'Sila pilih soalan',
    Provided: 'Jikalau',
    StartingScore: 'Markah permulaan',
    EndScoreScore: 'Markah akhir',
    ThenJumpTo: 'Kemudian beralih ke',
    DisplayLogic: 'Logik Paparan',
    BarDisplayLogic: 'Logik Paparan Bar',
    DisplayThisQuestionIfTheFollowingConditionsAreMet: 'Paparkan soalan jikalau syarat berikut telah dipenuhi',
    SetConditionsAndTestQuestionsToBeDisplayed: 'Tetapkan syarat untuk pemaparan soalan ',
    Just: 'dan',
    Perhaps: 'Atau',
    Arbitrarily: 'Sebarang',
    EqualTo: 'Same dengan',
    GreaterThan: 'Lebih besar daripada',
    LessThan: 'Kurang daripada',
    Betweenness: 'Di antara',
    AnyOption: 'Sebarang opsyen',
    NormalEndIncludedInTheResult: 'Penamatan biasa （diambil kira dalam hasil keputusan）',
    EarlyTerminationDoesNotCountTowardsResults: 'Penamatan awal (tidak diambil kira dalam hasil keputusan）',
    AddConditions: 'tambah Syarat',
    When: 'Apabila',
    ThisQuestion: 'Soalan ini',
    PleaseSelectACondition: 'Siplih pilih syarat',
    ThenDisplay: 'Paparkan kemudian',
    AddTestQuestions: 'Tambah soalan',
    AddDisplayLogic: 'Tunjukkan logik paparan',
    NewlyAdded: 'Baru ditambah',
    Give: 'Bagi',
    MutualInfluence: 'Saling mempengaruhi',
    Enter: 'Sila masukan',
    Help: 'Bantuan',
    GiveAnExample: 'Contohnya',
    MeetTheFollowingRequirements: 'Memenuhi syarat berikut',
    ShowThisIssueWhenConditionsAreMet: 'Tunjukkan isu ini jikalau syarat sudah dipenuhi',
    NormalCompletion: 'Penyelesaian Normal',
    ShowWhen: 'Tunjukkan bila',
    PleaseFillOInThisItem: 'Sila isikan item ini',
    PleaseSelectTheFollowingImage: 'Silah pilih gambar berikut',
    PleaseSelectAnOption: 'Sila pilih satu opsyen sahaja',
    SelectMultipleOptions: 'Sila pilih pelbagai opsyen berikut',
    SelectTheFollowingOptions: 'Sila pilih opsyen berikut',
    SortTheFollowingOptions: 'Sila susunkan item berikut',
    RateTheFollowingItems: 'Sila nilaikan setiap item',
    FillInTheFollowingInformation: 'Sila isikan kandungan',
    Headings: 'Pengepala',
    NextPage: 'Laman seterusnya',
    LastPage: 'Laman sebelumnya',
    FullName: 'Nama',
    Age: 'Umur',
    Year: 'Tahun',
    ContactInformation: 'Maklumat Perhubungan',
    PercentageOfEachItem: 'Sila pilih peratusan untuk setiap item ',
    EvaluateThisProject: 'Sila nilaikan projel ini',
    FillInMemberInformation: 'Sila isi maklumat ahli pasukan anda',
    Correct: 'Betul',
    Error: 'Ralat',
    SingleChoice: 'Pilih Satu',
    MultipleChoiceQuestions: 'Pilih Pelbagai',
    TrueOrFalse: 'Betul/Salah',
    ParagraphDescription: 'Penerangan Perenggan',
    TextFilling: 'Isikan Teks',
    QuestionCitation: 'Petikan Soalan',
    SearchForIssueLabelsOrIssueTitles: 'Sila cari label/tajuk soalan',
    BatchReference: 'Rujukan dalam kumpulan',
    ProblemLabel: 'Label Soalan',
    QuestionTitle: 'Tajuk Soalan',
    AffiliatedQuestionBank: 'Kepunyaan Bank Soalan',
    PersonalTemplate: 'Templat Peribadi',
    SystemTemplate: 'Templat Sistem',
    TimeCited: 'Masa Petikan',
    FilingNumber: '©2026 IMAKE NET SDN. BHD. (1514165-M)',
    Disable: 'Dilumpuhkan'
  },
  ImportQuestion: {
    TextImport: 'Import Teks',
    TextEditing: 'Edit',
    ExampleAndHelp: 'Contoh dan Bantuan',
    ClearText: 'Padamkan Teks',
    PasteTheDocumentHere: 'Sila salin dan tampal dokumen dalam format contoh di sini',
    QuestionPreview: 'Pratonton Tajuk',
    CreateProject: 'Bina Projek',
    WelcomeMessage: 'Mesej Alu-Aluan',
    PreviewExample: 'Pratonton Contoh',
    Example1: 'Nombor kecemasan in negera anda ialah',
    Example2: 'Apakah kaedah permarkahan adalah disokong oleh Surveytree dalam soalan jenis pilih pelbagai?',
    Example3: 'Hari terakhir bulan lunar kedua belas dipanggil Malam Tahun Baru。',
    Example4: 'Siapakah pengarang "Rekod Ahli Sejarah Agung"?',
    Example5: 'Sahkan jawapan untuk soalan di atas dan kemudian hantar',
    ScoringMethod1: 'Markah akan diberikan jikalau semua jawapan adalah betul',
    ScoringMethod2: 'Markah akan diberikan untuk jawapan yang betul sahaja',
    ScoringMethod3: 'Setiap jawapan mempunyai nilai markah yang berlainan',
    Yes: 'Ya',
    No: 'Tidak',
    FormatDescription: 'Penerangan Format',
    FormatDescription1: 'Tajuk Soalan sebaiknya bermula dengan nombor；',
    FormatDescription2: 'Adalah disyorkan untuk menanda Jenis Soalan di belakang tajuk soalan. Soalan yang tidak diberi penanda akan dikenal pasti secara automatik oleh sistem;',
    FormatDescription3: () =>{
      return `Jenis Soalan yang dapat dikenal pasti termaksuk:【${lang.ImportQuestion.WelcomeMessage}】、【${lang.main.SingleChoice}】、【${lang.main.MultipleChoiceQuestions}】、【${lang.main.TrueOrFalse}】、【${lang.main.fillInTheBlanks}】、【${lang.main.ParagraphDescription}】；`
    },
    FormatDescription4: 'Jikalau tidak dapat dikenal pasti, sila tambah sebaris tempat kosong di antara tajuk soalan；',
    FormatDescription5: 'Jangan meninggalkan baris kosong di antara pilihan.',
    FormatDescription6: () =>{
      return `Jikalau menambah【${lang.main.TextFilling}】elepas memilih jenis soalan【${lang.main.SingleChoice}】、【${lang.main.MultipleChoiceQuestions}】、【${lang.main.TrueOrFalse}】, kotak input teks akan ditambah.`
    },
    FormatDescription7: () =>{
      return `Selepas memilih 【${lang.main.SingleChoice}】、【${lang.main.MultipleChoiceQuestions}】、【${lang.main.TrueOrFalse}】，atau menambah teks “---Beralih ke Q4”、“---Tamatkan seperti biasa”、“---Tamatkan Awal” selepas memilih soalan 【${lang.main.fillInTheBlanks}】，logic peralihan akan ditambah.`
    },
    FormatDescription8: 'Menambah teks “【Label Soalan】” selepas soalan, label soalanakan ditambahkan.',
    FormatDescription9: 'Ucapan kesimpulan: Kesimpulan dibahagikan kepada',
    ClearPrompt: 'Anda pasti hendak memadamkan teks? Semua teks tidak akan dapat dipulihkan selepas pemadaman',
    ErrorMessage: 'Mesej Ralat',
    ProjectTitle: 'Tajuk Project',
    CorrectAnswer: 'Jawapan Betul',
    Creating: 'Sedang Dicipta',
    CreatedSuccessfully: 'Ciptaan Berjaya',
    ConclusionNormalEnd: 'Ucapan Kesimpulan - Tamatkan seperti biasa',
    ConclusionEarlyTermination: 'Ucapan Kesimpulan - Tamatkan awal'
  },
  Paper: {
    Title: 'Tajuk Soal Selidik',
    Depict: 'Terima kasih kerana meluangkan masa beberapa minit untuk menjawab soal selidik ini, mari kita mulakan sekarang!',
    endPageNormalMsg: 'Anda telah menyelesaikan soal selidik ini, terima kasih atas sokongan anda',
    endPageAdvanceMsg: 'Minta maaf, profil anda tidak sesuai untuk soal selidik ini, terima kasih atas penyertaan anda.',
  },
  AdvancedScript: {
    ConditionalFunctionsAndUsage: 'Fungsi and Penggunaan Bersyarat',
    Normal: 'Biasa',
    Normal1: '(Pilih Satu, Pilih Turun, Pilih Gambar, Betul/Salah, Pilih Pelbagai)',
    Normal2: '(Skala, Penarafan)',
    Normal3: '(Matriks Pilih Tunggal)',
    Normal4: '(Matriks Penarafan)',
    Normal5: '(Matriks Perenggan、Matriks Kombinasi)',
    Function: 'Fungsi',
    Exist1: 'Pilih pelbagai opsyen yang wujud',
    Exist2: 'Matriks pilih pelbagai opsyen yang wujud',
    Exist3: 'Pilih pelbagai opsyen yang tidak wujud',
    Exist4: 'Matriks pilih pelbagai opsyen yang tidak wujud',
    Include1: 'Pilih pelbagai yang mengandungi opsyen',
    Include2: 'Matriks pilih pelbagai yang mengandungi opsyen',
    IsShow: 'Tunjukkan',
    IsHide: 'Sembunyikan',
    IsAnswered: 'Sudah Dijawab',
    Help: 'Perlaksanaan Fungsi/Penggunaan',
    Help1: 'Tunjukkan Baris Matriks',
    Help2: 'Sembunyikan Baris Matriks',
    Help3: 'Tunjukkan Soalan',
    Help4: 'Sembunyikan Soalan',
    Help5: 'Tugasan',
    Help6: 'Langkau ke',
    Help7: 'Pulihkan Logik Langkauan',
    Illustrate: 'Penjelasan',
    Illustrate1: 'Kod Soalan',
    Illustrate2: 'Nombor Baris',
    Illustrate3: 'Nombor Pilihan',
    Illustrate4: 'Bilangan Pilihan Terpilih'
  },
  login: {
    accountLogin: 'Log Masuk ke Akaun',
    quickLogin: 'Log Masuk Pantas',
    userRegistration: 'Pendaftaran Pengguna',
    changePassword: 'Tukar Kata Laluan',
    forgotPassword: 'Lupa Kata Laluan',
    login: 'Log Masuk',
    pleaseEnterTheVerificationCode: 'Sila Masukkan Kod Pengesahan',
    obtainVerificationCode: 'Dapatlam Kod Pengesahan',
    registerNow: 'Daftar Sekarang',
    returnToLogin: 'Kembali ke Log Masuk',
    pleaseEnterNewPassword: 'Sila Masukkan Kod Kata Laluan Baru',
    loginWasSuccessful: 'Berjaya Log Masuk！',
    LoginSucceeded: 'Berjaya Log Masuk！',
    LogOutOfLogin: 'Log Keluar',
  },
  titleEditor: {
    QuoteTheAnswerFromThePreviousQuestion: 'Petik Jawapan daripada Soalan Sebelumnya',
    introduce: 'Pengenalan',
    quote: 'Petikan',
    CiteTheAnswersToThePreviousQuestionsToTheFollowingText: 'Petikan Jawapan dari Soalan Sebelumnya ke Teks Berikut',
    ThereAreCurrentlyNoTestQuestionsToCite: 'Tiada Soalan untuk Dipetik Buat Masa Ini',
    PleaseSelectTheTestQuestion: 'Sila Pilih Soalan',
    QuestionNumber: 'Nombor Soalan',
    SeniorEditor: 'Editor Lanjutan'
  },
  MyDownloads: {
    FileName: 'Nama Fail',
    FileType: 'Jenis Fail',
    Time: 'Masa',
    FileSize: 'Saiz Fail',
    State: 'Status',
    CanDownloaded: 'Boleh Dimuat Turun',
    Download: 'Muat Turun',
    DataPreparationProgress: 'Peyediaan Data Dalam Progres',
    CanDownloaded: 'Boleh Dimuat Turun',
    ExportException: 'Eksportkan Pengecualian',
    DataExpiration: 'Data Tamat Tempoh'
  },
  ...UserAnswer,
  ...PublishProject,
  ...SetUp,
  ...Appearance,
  ...DataRecycling,
  ...Preview,
  ...QuesLibrary,
  ...Personal,
  ...Mywallet,
  ...Quota,
  ...element
};
export default lang